import { render, staticRenderFns } from "./basicssetup.vue?vue&type=template&id=300e6955&scoped=true&"
import script from "./basicssetup.vue?vue&type=script&lang=js&"
export * from "./basicssetup.vue?vue&type=script&lang=js&"
import style0 from "./basicssetup.vue?vue&type=style&index=0&id=300e6955&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300e6955",
  null
  
)

export default component.exports